<template lang="pug">
  section.spinner-container.flex.content-center.justify-center.flex-wrap
    .spinner.ease-linear.rounded-full.border-gray-200(:style="style")
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        size: {
            type: Number,
            default: 24 // possible values: https://tailwindcss.com/docs/width/#fixed-width
        },
        thickness: {
            type: Number,
            default: 4 // possible values: 1 - 8
        }
    },
    computed: {
        style() {
            let styles = {};

            let width = this.thickness;
            if (this.thickness < 1) width = 1;
            else if (this.thickness > 8) width = 8;

            styles['border-width'] = `${width}px`;

            let size = this.size;
            styles.height = `${size * 0.25}rem`;
            styles.width = `${size * 0.25}rem`;

            return styles;
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>

.spinner-container
  min-height: 100%
  flex-grow: 1

.spinner
  border-top-color: var(--color-primary)
  animation: spinner 1.5s linear infinite

@keyframes spinner
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>
